import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import rootReducer from '../reducers'

const loggerMiddleware = createLogger()

// In development, use the browser's Redux dev tools extension if installed
const enhancers = []
const isDevelopment = process.env.NODE_ENV === 'development'
if (
	isDevelopment &&
	typeof window !== 'undefined' &&
	window.devToolsExtension
) {
	enhancers.push(window.devToolsExtension())
}

export const store = createStore(
	rootReducer,
	compose(
		applyMiddleware(thunkMiddleware),
		...enhancers
	)
)
